<template>
  <div class="table-responsive">
    <table class="table bg-white table-sm table-striped table-middle fs-sm">
      <thead>
        <tr>
          <th v-if="$root.user.isAdmin" class="th-shrink" />
          <th>Súčasný dodávateľ</th>
          <th class="text-right">Vodné (m3)</th>
          <th class="text-right">Stočné (m3)</th>
          <th class="text-right">Zrážky (m3)</th>
          <th class="text-right">Dátum zmeny</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id">
          <td v-if="$root.user.isAdmin" class="th-shrink">
            <b-dropdown class="btn-p-0" no-caret variant="link">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item @click.prevent="edit(item.id)">
                <b-icon class="mr-1" icon="pencil-square" />
                Upraviť
              </b-dropdown-item>
              <b-dropdown-item
                class="text-danger"
                @click.prevent="remove(item.id)"
              >
                <b-icon class="mr-1" icon="trash" />
                Vymazať
              </b-dropdown-item>
            </b-dropdown>
          </td>
          <td>
            <template v-if="item._provider">
              {{ item._provider.name }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.water">
              {{ item.water | formatNumber(4) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.sewerage">
              {{ item.sewerage | formatNumber(4) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.rainfall">
              {{ item.rainfall | formatNumber(4) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.changeDate">
              {{ item.changeDate | formatDate }}
            </template>
            <template v-else> - </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    energetic: Object,
  },
  methods: {
    edit(id) {
      this.$parent.$parent.$refs.contractForm.id = id
      this.$parent.$parent.add({ type: 'water', edit: true })
    },
    remove(id) {
      this.$parent.$parent.remove(id)
    },
  },
}
</script>
